import { useEffect } from "react";

const SITE_NAME = "Cloudship";
const SITE_URL = "https://cloud-ship.de";
const DEFAULT_OG = `${SITE_URL}/og-image.jpg`;

function setMeta(selector, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    const [, key, val] = selector.match(/\[(.*?)="(.*?)"\]/) || [];
    if (key && val) el.setAttribute(key, val);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Use inside any page component to update document title + OG/Twitter meta tags.
 * Restores defaults on unmount is not needed because the next page sets its own.
 */
export function useSeo({ title, description, image, path = "/", type = "website", lang = "en" }) {
  useEffect(() => {
    const fullTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — Microsoft Azure Cloud Consulting`;
    const desc = description || "Microsoft Azure cloud consulting in Germany. Enterprise-Scale Landing Zones, CAF, WAF and DevOps frameworks delivered by senior architects.";
    const ogImage = image || DEFAULT_OG;
    const url = `${SITE_URL}${path}`;

    document.title = fullTitle;
    document.documentElement.lang = lang;

    setMeta('meta[name="description"]', "content", desc);
    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[property="og:description"]', "content", desc);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[property="og:image"]', "content", ogImage);
    setMeta('meta[property="og:type"]', "content", type);
    setMeta('meta[property="og:locale"]', "content", lang === "de" ? "de_DE" : "en_US");
    setMeta('meta[name="twitter:title"]', "content", fullTitle);
    setMeta('meta[name="twitter:description"]', "content", desc);
    setMeta('meta[name="twitter:image"]', "content", ogImage);

    setLink("canonical", url);
  }, [title, description, image, path, type, lang]);
}
